import axiosInstance from "./axiosInstance";

export const createStrategyCall = (payload) => {
  return axiosInstance.post("/stratergy-calls", payload);
};